<app-navigation #navigationBar></app-navigation>
<!--<header #header>-->
<!--  <div class="masthead">-->
<!--    <ng-container *ngFor="let i of [0,1]">-->
<!--      <div *ngIf="i==index && !loading" [@flyInOut] [ngClass]="'background div'+i"></div>-->
<!--    </ng-container>-->
<!--    <div *ngIf="loading" class="background div0"></div>-->
<!--  </div>-->
<!--  <div class="masthead-arrow">-->
<!--    <img decoding="async" width="115" height="150"-->
<!--         src="https://quickhub.co.il/wp-content/uploads/2023/10/Path-25-1.png"-->
<!--         class="attachment-large size-large wp-image-386" alt="">-->
<!--  </div>-->
<!--  <div class="masthead-background-overlay"></div>-->
<!--  <div class="masthead-greetings"></div>-->
<!--</header>-->
